/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  AcceptInvitationDto,
  DataEnvelopeOfLoginResponseDto,
  DataEnvelopeOfObject,
  ErrorEnvelope,
  ForgotPasswordDto,
  LoginDto,
  RefreshTokenDto,
  ResetPasswordDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Realiza login do usuário
 */
export const login = (
  loginDto: LoginDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfLoginResponseDto>(
    {
      url: `/v1/auth/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loginDto,
      signal,
    },
    options,
  )
}

export const getLoginMutationKey = () => ['login'] as const

export const getLoginMutationOptions = <TError = ErrorEnvelope, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    LoginMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  LoginMutationVariables,
  TContext
> => {
  const mutationKey = getLoginMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, LoginMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {}

    return login(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
export type LoginMutationBody = LoginDto
export type LoginMutationError = ErrorEnvelope
export type LoginMutationVariables = { data: LoginDto }

/**
 * @summary Realiza login do usuário
 */
export const useLogin = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof login>>,
      TError,
      LoginMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  LoginMutationVariables,
  TContext
> => {
  return useMutation(getLoginMutationOptions(options), queryClient)
}
/**
 * @summary Renova o access token
 */
export const refreshToken = (
  nullRefreshTokenDto?: null | RefreshTokenDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfLoginResponseDto>(
    {
      url: `/v1/auth/refresh`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: nullRefreshTokenDto,
      signal,
    },
    options,
  )
}

export const getRefreshTokenMutationKey = () => ['refreshToken'] as const

export const getRefreshTokenMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    RefreshTokenMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  RefreshTokenMutationVariables,
  TContext
> => {
  const mutationKey = getRefreshTokenMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshToken>>,
    RefreshTokenMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return refreshToken(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshToken>>>
export type RefreshTokenMutationBody = null | RefreshTokenDto | undefined
export type RefreshTokenMutationError = ErrorEnvelope
export type RefreshTokenMutationVariables = { data?: null | RefreshTokenDto }

/**
 * @summary Renova o access token
 */
export const useRefreshToken = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshToken>>,
      TError,
      RefreshTokenMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  RefreshTokenMutationVariables,
  TContext
> => {
  return useMutation(getRefreshTokenMutationOptions(options), queryClient)
}
/**
 * @summary Realiza logout do usuário
 */
export const logout = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/auth/logout`, method: 'POST', signal },
    options,
  )
}

export const getLogoutMutationKey = () => ['logout'] as const

export const getLogoutMutationOptions = <TError = ErrorEnvelope, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext>
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext> => {
  const mutationKey = getLogoutMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {
    return logout(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

export type LogoutMutationError = ErrorEnvelope

/**
 * @summary Realiza logout do usuário
 */
export const useLogout = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError, void, TContext>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof logout>>, TError, void, TContext> => {
  return useMutation(getLogoutMutationOptions(options), queryClient)
}
/**
 * @summary Solicita recuperação de senha
 */
export const forgotPassword = (
  forgotPasswordDto: ForgotPasswordDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    {
      url: `/v1/auth/forgot-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: forgotPasswordDto,
      signal,
    },
    options,
  )
}

export const getForgotPasswordMutationKey = () => ['forgotPassword'] as const

export const getForgotPasswordMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    ForgotPasswordMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  ForgotPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getForgotPasswordMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPassword>>,
    ForgotPasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return forgotPassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
export type ForgotPasswordMutationBody = ForgotPasswordDto
export type ForgotPasswordMutationError = ErrorEnvelope
export type ForgotPasswordMutationVariables = { data: ForgotPasswordDto }

/**
 * @summary Solicita recuperação de senha
 */
export const useForgotPassword = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof forgotPassword>>,
      TError,
      ForgotPasswordMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  ForgotPasswordMutationVariables,
  TContext
> => {
  return useMutation(getForgotPasswordMutationOptions(options), queryClient)
}
/**
 * @summary Reseta a senha do usuário
 */
export const resetPassword = (
  resetPasswordDto: ResetPasswordDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    {
      url: `/v1/auth/reset-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resetPasswordDto,
      signal,
    },
    options,
  )
}

export const getResetPasswordMutationKey = () => ['resetPassword'] as const

export const getResetPasswordMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    ResetPasswordMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  ResetPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getResetPasswordMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPassword>>,
    ResetPasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return resetPassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
export type ResetPasswordMutationBody = ResetPasswordDto
export type ResetPasswordMutationError = ErrorEnvelope
export type ResetPasswordMutationVariables = { data: ResetPasswordDto }

/**
 * @summary Reseta a senha do usuário
 */
export const useResetPassword = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetPassword>>,
      TError,
      ResetPasswordMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  ResetPasswordMutationVariables,
  TContext
> => {
  return useMutation(getResetPasswordMutationOptions(options), queryClient)
}
export const acceptInvitation = (
  acceptInvitationDto: AcceptInvitationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    {
      url: `/v1/auth/accept-invitation`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: acceptInvitationDto,
      signal,
    },
    options,
  )
}

export const getAcceptInvitationMutationKey = () => ['acceptInvitation'] as const

export const getAcceptInvitationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvitation>>,
    TError,
    AcceptInvitationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptInvitation>>,
  TError,
  AcceptInvitationMutationVariables,
  TContext
> => {
  const mutationKey = getAcceptInvitationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptInvitation>>,
    AcceptInvitationMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return acceptInvitation(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AcceptInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvitation>>
>
export type AcceptInvitationMutationBody = AcceptInvitationDto
export type AcceptInvitationMutationError = unknown
export type AcceptInvitationMutationVariables = { data: AcceptInvitationDto }

export const useAcceptInvitation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptInvitation>>,
      TError,
      AcceptInvitationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acceptInvitation>>,
  TError,
  AcceptInvitationMutationVariables,
  TContext
> => {
  return useMutation(getAcceptInvitationMutationOptions(options), queryClient)
}
